export const offices = [
  {
    title: 'HAUPTSITZ',
    items: [
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/poland-v2.svg',
        country: 'Polen',
        city: 'Warschau',
      },
    ],
  },
  {
    title: 'ENTWICKLUNGSZENTREN',
    items: [
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/poland-v2.svg',
        country: 'Polen',
        mobileCountry: 'PL',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/Lithuania.svg',
        country: 'Litauen',
        mobileCountry: 'LT',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/hungary.svg',
        country: 'Ungarn',
        mobileCountry: 'HU',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/Georgia-v2.svg',
        country: 'Georgien',
        mobileCountry: 'GE',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/kazakhstan.svg',
        country: 'Kasachstan',
        mobileCountry: 'KZ',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/azerbaijan.svg',
        country: 'Aserbaidschan',
        mobileCountry: 'AZ',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/india-v2.svg',
        country: 'Indien',
        mobileCountry: 'IN',
      },
    ],
  },
  {
    title: 'REPRÄSENTANZ',
    items: [
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/United-kingdom-v2.svg',
        country: 'Vereinigtes Königreich',
        mobileCountry: 'GB',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/United-states-of-america-v2.svg',
        country: 'Vereinigte Staaten',
        mobileCountry: 'US',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/Germany.svg',
        country: 'Deutschland',
        mobileCountry: 'DE',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/Ireland-v2.svg',
        country: 'Irland',
        mobileCountry: 'IE',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/Lithuania.svg',
        country: 'Litauen',
        mobileCountry: 'LT',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/Cyprus.svg',
        country: 'Zypern',
        mobileCountry: 'CY',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/UAE-v2.svg',
        country: 'VAE',
        mobileCountry: 'AE',
      },
    ],
  },
];
